import './Header.css';
import {Nav, Navbar, Button, Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { openSidebar } from "../redux/sidebarSlice";

const Header = () => {
    const dispatch = useDispatch();
    return (
        <Navbar id = "NavigationHeader">
            <Container id = "headerContainer">
                <Button id="sidebarButton" variant="outline-success" onClick={() => dispatch(openSidebar())}>☰</Button>
                <Navbar.Brand id ="LogoText" href="#home">Sentimental</Navbar.Brand>
            </Container>
        </Navbar>
    );
}

export default Header;